import { render, staticRenderFns } from "./MedicalInsuranceLevelForm.vue?vue&type=template&id=0b745528&"
import script from "./MedicalInsuranceLevelForm.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports